import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "prc_cmc_token";

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Load persisted token on module init
const stored = typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const setAuthToken = (t) => {
    if (t) {
        api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
        try { window.localStorage.setItem(TOKEN_KEY, t); } catch {}
    } else {
        delete api.defaults.headers.common["Authorization"];
        try { window.localStorage.removeItem(TOKEN_KEY); } catch {}
    }
};

export function formatApiError(detail) {
    if (detail == null) return "エラーが発生しました";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const ROLE_LABELS = {
    super_admin: "スーパー管理者（運営）",
    company_admin: "管理者（テナント）",
    staff: "スタッフ",
};

export const ROLE_DESCRIPTIONS = {
    super_admin: "システム運営者。全テナントへのアクセス権限を持ちます。",
    company_admin: "テナント管理者。自社の車両・ユーザー・プランを管理できます。",
    staff: "テナントのスタッフ。点検実施・履歴閲覧・帳票出力ができます。",
};

export const PLAN_LABELS = {
    starter: "Starter",
    business: "Business",
    enterprise: "Enterprise",
};
